import React, { useState } from "react";
import { Query } from "@cubejs-client/core";
import { useCubeQuery } from "@cubejs-client/react";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../layout/LoadingComponent";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const tableStyle: React.CSSProperties = {
    width: "100%",
    borderCollapse: "collapse",
};

const thStyle: React.CSSProperties = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
    width: "30%",
};

const tdStyle: React.CSSProperties = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
    width: "70%",
    whiteSpace: "normal",
};

const alternatingRowStyles: React.CSSProperties[] = [
    { backgroundColor: "#f2f2f2" },
    { backgroundColor: "white" },
];

export default observer(function ReportObservanceDetails({
    sirId,
}: {
    sirId: string;
}) {
    const [currentRecordIndex, setCurrentRecordIndex] = useState(0);

    const query: Query = {
        dimensions: [
            "VwSiteInspectionReportDetails.obsactid",
            "VwSiteInspectionReportDetails.obsactobservance",
            "VwSiteInspectionReportDetails.obsactphoto",
        ],
        order: {
            "VwSiteInspectionReportDetails.obsactobservance": "asc",
        },
        filters: [
            {
                dimension: "VwSiteInspectionReportDetails.id",
                operator: "equals",
                values: [sirId ? sirId : "00000000-0000-0000-0000-000000000000"],
            },
            {
                dimension: "VwSiteInspectionReportDetails.obsactid",
                operator: "set",
            },
        ],
    };
    const { resultSet, isLoading, error } = useCubeQuery(query);

    // Check for errors or missing sirId
    if (!sirId || error) {
        return (
            <div>
                <div>
                    <b>Please select a Report</b>
                </div>
                <div>
                </div>

            </div>
        );
    }

    if (isLoading || !resultSet) {
        return <LoadingComponent content="Loading..." />;
    }

    const totalRecords = resultSet.tablePivot().length;

    const obsactobservance =
        resultSet.tablePivot().map((row) => row["VwSiteInspectionReportDetails.obsactobservance"])[
        currentRecordIndex
        ];
    const obsactphoto =
        resultSet.tablePivot().map((row) => row["VwSiteInspectionReportDetails.obsactphoto"])[
        currentRecordIndex
        ];

    const defaultImageSource = "/assets/not-found-icon-26.jpg";

    const navigateToPreviousRecord = () => {
        if (currentRecordIndex > 0) {
            setCurrentRecordIndex(currentRecordIndex - 1);
        }
    };

    const navigateToNextRecord = () => {
        if (currentRecordIndex < totalRecords - 1) {
            setCurrentRecordIndex(currentRecordIndex + 1);
        }
    };

    const currentRecordNumber = currentRecordIndex + 1;

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button onClick={navigateToPreviousRecord}>
                    <KeyboardArrowLeft /> {/* Left arrow icon */}
                </button>
                <div>
                    {currentRecordNumber} of {totalRecords}
                </div>
                <button onClick={navigateToNextRecord}>
                    <KeyboardArrowRight /> {/* Right arrow icon */}
                </button>
            </div>
            <div>
                <b>Observance</b>
            </div>
            <table style={tableStyle}>
                <tbody>
                    <tr style={alternatingRowStyles[0]}>
                        <th style={thStyle}>Observance</th>
                        <td style={tdStyle}>{obsactobservance}</td>
                    </tr>
                </tbody>
            </table>
            {obsactphoto && (
                <div>
                    <img
                        src={obsactphoto.toString()}
                        alt="Report Photo"
                        style={{ maxWidth: "100%", width: "300px", height: "200px" }}
                    />
                </div>
            )}
        </div>
    );
});
